 
import http from "@/http/service"
 
const Cupons = ()=> {
    return http.get(`/parceiro/cupons`)

}

const FinalizarAtendimento = id => {
    return http.put(`/parceiro/cupons/${id}`)

}

export default {
   Cupons, 
   FinalizarAtendimento, 
}